import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import logoCompleto from '../../assets/img/logos/osviel-transparente.png';
import logoSimbolo from '../../assets/img/logos/osviel-simbolo.png';

// En la barra superior el texto no cabe: se muestra solo el símbolo
const Logo = ({ at, width, height, className, ...rest }) => {
  const logo = at === 'navbar-top' ? logoSimbolo : logoCompleto;

  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center font-weight-extra-bold fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img className="mr-2" src={logo} alt="Logo" width={width} height={width ? undefined : height} />
        {/* <span className="text-sans-serif">falcon</span> */}
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string
};

Logo.defaultProps = { at: 'auth', height: 100 };

export default Logo;
